// VertFeaturesDialog.tsx — Up to 19 vertical feature strips (fvvar)

import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { usePendingSlot } from './usePendingSlot';
import { useShallowStore } from '../store/useStore';

const FIELDS = [
  { key: 'mark',   label: 'Mark',    type: 'text'   as const },
  { key: 'x',      label: 'X Ctr',   type: 'number' as const, unit: '"', min: 0 },
  { key: 'width',  label: 'Width',   type: 'number' as const, unit: '"', min: 0 },
  { key: 'depth',  label: 'Depth',   type: 'number' as const, unit: '"', min: 0 },
  { key: 'yStart', label: 'Y Start', type: 'number' as const, unit: '"', min: 0 },
  { key: 'yEnd',   label: 'Y End',   type: 'number' as const, unit: '"', min: 0 },
];

export default function VertFeaturesDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = usePendingSlot('fvvar', panel?.fvvar ?? [],
    (px, _py, mark) => ({ mark, x: px }),
    { mark: '', type: 'reveal' as const, x: 0, width: 0, depth: 0.75, yStart: 0, yEnd: 0 });
  if (!panel) return null;

  return (
    <DialogBase title="Vertical Feature Strips (19 max)" onOk={() => updatePanel(panel.id, { fvvar: slots })}>
      <SlotEditor
        slots={slots}
        fields={FIELDS}
        maxSlots={19}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', type: 'reveal' as const, x: 0, width: 0, depth: 0.75, yStart: 0, yEnd: 0 })}
        label="FV"
      />
    </DialogBase>
  );
}
